export const infraCurrentDate = {
    now: () => { return new Date() }
}
